module.exports = __webpack_public_path__ + "img/less_than_black.0910bd1a.svg";